"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unloadBehavior = void 0;

var _logger = _interopRequireDefault(require("./utils/logger"));

var _adobe = require("./utils/adobe");

var _misc = require("./utils/misc");

var unloadBehavior = function unloadBehavior(e) {
  var adobeDataStatus = (0, _adobe.getAdobeDataStatus)();

  if (adobeDataStatus === 'pending') {
    _logger["default"].error(new Error('User left page before adobe data was fetched'));
  } else {
    if (!(0, _misc.noWindow)() && window._rswClients) {
      Object.values(window._rswClients).map(function (client) {
        client.batcher.flushCachedEvents();
      });
    }
  }

  delete e.returnValue;
  return undefined;
};

exports.unloadBehavior = unloadBehavior;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-sdk-web/dist/cjs/unloadBehavior.js
// module id = 3455
// module chunks = 11